import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";

const FlagLabel = ({ label, mode = -1 }) => {
  const controls = useAnimation();

  useEffect(() => {
    if (mode !== -1) {
      controls.start({ maxHeight: 96 });
    } else {
      controls.start({ maxHeight: 0 });
    }
  }, [mode, controls]);

  return (
    <motion.div
      initial={{ maxHeight: 0 }}
      animate={controls}
      className={`flex w-full origin-bottom transform items-center justify-center overflow-hidden transition-all duration-500`}
    >
      <div
        className={`text-md mx-1 w-full items-center justify-center overflow-hidden overflow-ellipsis rounded px-2 py-1 text-center shadow`}
      >
        <span className="font-semibold">{label}</span>
      </div>
    </motion.div>
  );
};
export default FlagLabel;
